import { useState } from 'react';
import { Download } from 'lucide-react';
import toast from 'react-hot-toast';
import { Button } from '../../../components/Button';
import { exportRows, type ExportColumn } from '../../../lib/export';

/**
 * Export the given rows as CSV or Excel (the app's dependency-free writer).
 * Disabled when there is nothing to export.
 */
export function ExportButton<T>({ rows, columns, baseName, disabled }: {
    rows: T[];
    columns: ExportColumn<T>[];
    baseName: string;
    disabled?: boolean;
}) {
    const [open, setOpen] = useState(false);
    const run = (format: 'csv' | 'xlsx') => {
        setOpen(false);
        if (!rows.length) { toast.error('Nothing to export for this range.'); return; }
        const n = exportRows(rows, columns, format, baseName);
        toast.success(`Exported ${n} row${n === 1 ? '' : 's'}.`);
    };
    return (
        <div className="relative">
            <Button size="sm" variant="secondary" leftIcon={<Download className="size-4" />}
                disabled={disabled || !rows.length} onClick={() => setOpen((o) => !o)}>
                Export
            </Button>
            {open && (
                <>
                    <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
                    <div className="absolute right-0 z-50 mt-1 w-40 overflow-hidden rounded-lg border border-border bg-card shadow-lg">
                        <button className="block w-full px-3 py-2 text-left text-sm text-foreground hover:bg-secondary" onClick={() => run('csv')}>
                            CSV (.csv)
                        </button>
                        <button className="block w-full px-3 py-2 text-left text-sm text-foreground hover:bg-secondary" onClick={() => run('xlsx')}>
                            Excel (.xlsx)
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
